document.addEventListener('DOMContentLoaded', () => {
  const headers = document.querySelectorAll('[data-bb-shop-header]');

  headers.forEach((header) => {
    const menuButton = header.querySelector('[data-bb-menu-button]');
    const mobileMenu = header.querySelector('[data-bb-mobile-menu]');

    if (!menuButton || !mobileMenu) {
      return;
    }

    const setMenuState = (isOpen) => {
      menuButton.classList.toggle('is-open', isOpen);
      mobileMenu.classList.toggle('is-open', isOpen);

      menuButton.setAttribute('aria-expanded', String(isOpen));
      menuButton.setAttribute(
        'aria-label',
        isOpen ? 'Close menu' : 'Open menu'
      );

      mobileMenu.setAttribute('aria-hidden', String(!isOpen));
    };

    menuButton.addEventListener('click', (event) => {
      event.stopPropagation();

      const isCurrentlyOpen =
        menuButton.getAttribute('aria-expanded') === 'true';

      setMenuState(!isCurrentlyOpen);
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) {
        setMenuState(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setMenuState(false);
        menuButton.focus();
      }
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        setMenuState(false);
      });
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1050) {
        setMenuState(false);
      }
    });
  });
});